/**
 * Returns true if the string is a valid URL or an empty string
 * @param value: string
 */
export default function validURL(value: string) {
  const res = value.match(
    /(http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%.~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%.~#?&//=]*)/gi
  );
  return value == "" ? true : res !== null;
}
